import { NoBlending, ShaderMaterial, Uniform, Vector3 } from "three";

import fragmentShader from "./glsl/GamutCompress.frag";
import vertexShader from "./glsl/Common.vert";
import * as THREE from "three";

/**
 * A simple copy shader material.
 */

export class GamutCompressMaterial extends ShaderMaterial {

    /**
     * Constructs a new Gamut Compress material.
     */

    constructor() {
        super({
            name: "GamutCompressMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                invert: new Uniform(false),
                colorspace: new Uniform(1),
                distanceCMY: new Uniform(new Vector3(0.1, 0.2, 0.1)),
                thresholdCMY: new Uniform(new Vector3(0.15, 0.15, 0.15)),
                power: new Uniform(1),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });

        /** @ignore */
        this.toneMapped = false;

    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
